const GenerateUrl = (data, valuePairs) => {
  let url = "";
  let putAnd = false;
  valuePairs.forEach((element) => {
    let paramValue = data[element.value];
    if (paramValue !== undefined && paramValue !== null && paramValue !== "") {
      if (putAnd) {
        url += "&";
      } else {
        url = "?";
        putAnd = true;
      }
      url += `${element.keyword}=${data[element.value]}`;
    }
  });

  return url;
};

export default GenerateUrl;
